export class CommissionRuleService {
    static async getAll() {
        return [];
    }

    static resolveForDeal(deal) {
        return null;
    }

    static applyRuleToDeal(deal, rule = null) {
        if (rule) return { ...deal, ...rule };
        return deal;
    }

    static async save(rule) {
        return rule;
    }

    static async delete() {
        return null;
    }
}
